import { render, staticRenderFns } from "./TabsB.vue?vue&type=template&id=9f3b5d96&lang=pug&"
import script from "./TabsB.vue?vue&type=script&lang=js&"
export * from "./TabsB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports